import * as React from 'react';
import { getInitials } from '../../utils/chat/format';

function Avatar({
  name, size = 9, online, square = false, src,
}: { name?: string; size?: number; online?: boolean; square?: boolean; src?: string | null }) {
  const n = name || '?';
  const initials = getInitials(n);
  const px = size * 4; // Tailwind unit → pixels (1 unit = 4px)
  const fontPx = size < 8 ? 10 : size < 10 ? 12 : 14;
  const rounded = square ? 'rounded-xl' : 'rounded-full';
  const cssVars = { '--avatar-size': `${px}px`, '--avatar-font-size': `${fontPx}px` } as React.CSSProperties;

  // Reset the error flag whenever the URL changes so a new upload re-attempts.
  const [imgError, setImgError] = React.useState(false);
  React.useEffect(() => { setImgError(false); }, [src]);
  const showImg = !!src && !imgError;
  // Initials fallback uses the theme's container/text pair (>=4.5:1 in every
  // theme) instead of a name-hashed gradient with white text (~2.5:1).
  const fallbackStyle: React.CSSProperties = showImg
    ? {}
    : { background: 'var(--gt-primary-container)', color: 'var(--gt-text-primary)' };

  return (
    <div className="gc-avatar" style={cssVars}>
      <div
        className={`gc-avatar__inner ${rounded} flex items-center justify-center font-semibold select-none shadow-sm ${online ? 'ring-2 ring-white' : ''}`}
        style={fallbackStyle}
      >
        {showImg ? (
          <img
            src={src as string}
            alt={n}
            className={`gc-avatar__img ${rounded}`}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={() => setImgError(true)}
            draggable={false}
          />
        ) : (
          initials
        )}
      </div>
      {online !== undefined && (
        <span className={`gc-avatar__status-dot ${online ? 'is-online gc-online-dot' : ''}`} />
      )}
    </div>
  );
}

export default Avatar;
